module.exports = __webpack_public_path__ + "img/venus_logo.806c721f.png";